// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_d8-3";
export var flatBottomCorners = "_d8-5";
export var productImage = "_d8-0";
export var quantityContainer = "_d8-2";
export var quantityHeader = "_d8-6";
export var tooltip = "_d8-1";
export var wrapAndEllipsesOverflow = "_d8-4";